import { Typography } from '@mui/material';

interface FormErrorProps {
  message: string | null;
}

export function FormError({ message }: FormErrorProps) {
  if (message === null) return null;
  return (
    <Typography variant="body2" color="error" sx={{ mb: 1.5, fontSize: '0.8125rem' }}>
      {message}
    </Typography>
  );
}
